export default __webpack_public_path__ + "static/media/Imagen_Backoffice_mas_eficiente.70d86efd.png";